export default __webpack_public_path__ + "static/media/arrow-down-dark.fcdfbe13.svg";